import styled from "styled-components";

export const Hover = styled.a`
  text-decoration: none;
  :hover > .b-card {
    /* background-color: grey; */
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.3);
    margin: 10px 0;
  }
`;
